import type { SystemStyleObject } from '@chakra-ui/theme-tools'
import { useThemeColors } from 'hooks/useThemeColors'

export const useInteractiveTableHeaderCellStyles = (): SystemStyleObject => {
  const COLORS = useThemeColors()

  return {
    cursor: 'pointer',
    fontWeight: '800!important',
    color: `${COLORS.zircuitPrimary}!important`,
    _hover: {
      color: `${COLORS.zircuitLight}!important`,
    },
  }
}
